import { motion } from "framer-motion";
import { ReactNode } from "react";

interface Props {
  children: ReactNode;
  normal?: boolean;
  delay?: number;
  duration?: number;
  style?: {};
}
export function ScaleDown({
  children,
  style,
  normal,
  delay = 0,
  duration = 0.7,
}: Props) {
  return (
    <motion.div
      initial={{ opacity: 0, x: -60 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 60 }}
      transition={{ duration: duration, delay: delay }}
      style={{
        width: normal ? "100%" : "fit-content",
        transitionTimingFunction: "cubic-bezier(0.645,0.045,0.355,1)",
        marginInline: normal ? "0px" : "auto",
        ...style,
      }}
    >
      {children}
    </motion.div>
  );
}
